import React, { useState, useMemo } from 'react';
import Button from 'chameleon/ui-stack/ui/base/button';
import Tooltip from 'chameleon/ui-stack/ui/base/tooltip';

const useCollapsible = (showMoreNumber, isAlert) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const text = isCollapsed ? `+${showMoreNumber}` : 'hide';
  const useAlertTheme = isAlert && isCollapsed;

  const button = (
    <Button
      id="resource-assign-titles-show-more-btn"
      className="mb-4.2"
      isSecondary={!useAlertTheme}
      isAlert={useAlertTheme}
      isLink
      onClick={() => setIsCollapsed(!isCollapsed)}
    >
      {text}
    </Button>
  );

  const buttonElement = useMemo(() => {
    const showExpandButton = showMoreNumber > 0 && isCollapsed;
    const showCollapseButton = showMoreNumber > 0 && !isCollapsed;

    if (showExpandButton) {
      return (
        <Tooltip
          target="resource-assign-titles-show-more-btn"
          description="Show all videos"
        >
          {button}
        </Tooltip>
      );
    }

    if (showCollapseButton) {
      return button;
    }

    return null;
  }, [isCollapsed, showMoreNumber, isAlert]);

  return {
    isCollapsed,
    button: buttonElement,
  };
};

export default useCollapsible;
